import { DirectionDoc } from './Invoice';

export interface Payment {
  id: string;
  accountingDocumentId: string;
  direction: DirectionDoc;
  source: string;
  destination: string;
  price: number;
  currency: string;
}

export enum PaymentStatus {
  NOT_PAID = 'NoPayment',
  PARTIALLY_PAID = 'PartiallyPaid',
  PAID = 'Paid',
  OVERPAID = 'PaidWithOverpayment',
}

export enum PaymentStatusTranslated {
  'NoPayment' = 'page.payment.not-paid',
  'PartiallyPaid' = 'page.payment.partially-paid',
  'Paid' = 'page.payment.paid',
  'PaidWithOverpayment' = 'page.payment.overpaid',
}

export enum PaymentMethod {
  BANK_TRANSFER = 'BankTransfer',
  CARD = 'Card',
  CASH = 'Cash',
  OTHER = 'Other',
}

export enum PaymentMethodTranslated {
  'BankTransfer' = 'page.payment.bank-transfer',
  'Card' = 'page.payment.card',
  'Cash' = 'page.payment.cash',
  'Other' = 'page.payment.other',
}
